module.exports = __webpack_public_path__ + "img/Bouclier06.57d59e0c.png";